export function extendByRepetition(array, finalLength) {
    const result = [];
    for (let i = 0; i < finalLength; i++) {
        result.push(array[i % array.length]);
    }
    return result;
}
